"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLeaderboardEmbedCode = exports.getThermometerEmbedCode = exports.getFormEmbedCode = void 0;
exports.getEmbedHtml = getEmbedHtml;
exports.getEmbedV2Html = getEmbedV2Html;
const enums_1 = require("../enums");
const routes_1 = require("./routes");
function getEmbedHtml({ src, iframHeight, divHeight, divPaddingTop, allowPaymentRequest, lazy, title = "Donation form powered by Zeffy", }) {
    // Namespaced data-* so host-page lazy-loaders don't auto-promote it to `src` and load a second form.
    const srcAttribute = lazy ? `data-zeffy-embed-src='${src}'` : `src='${src}'`;
    return `<div style="position:relative;overflow:hidden;${divHeight ? `height:${divHeight};` : ""}width:100%;${divPaddingTop ? `padding-top:${divPaddingTop};` : ""}"><iframe title='${title}' style='position: absolute; border: 0; top:0;left:0;bottom:0;right:0;width:100%;height:${iframHeight}' ${srcAttribute} ${allowPaymentRequest ? "allowpaymentrequest" : ""} allowTransparency="true"></iframe></div>`;
}
function getEmbedV2Html({ frontendUrl, embedPath, fallbackEmbedHtml, }) {
    const scriptUrl = `${frontendUrl}/embed/v2/zeffy-embed.js`;
    return `<div>
  <div data-zeffy-embed data-form-url="${embedPath}"></div>
  <div data-zeffy-embed-fallback style="display:none;">
    ${fallbackEmbedHtml}
  </div>
  <script
    src="${scriptUrl}"
    onerror="document.querySelectorAll('[data-zeffy-embed-fallback]').forEach(function(el){el.style.display='block';el.querySelectorAll('iframe[data-zeffy-embed-src]').forEach(function(f){f.src=f.getAttribute('data-zeffy-embed-src');});});">
  </script>
</div>`;
}
const getFormEmbedCode = ({ frontendUrl, embedPath, formType, }) => getEmbedV2Html({
    frontendUrl,
    embedPath,
    fallbackEmbedHtml: getEmbedHtml({
        src: `${frontendUrl}${embedPath}`,
        iframHeight: "100%",
        divHeight: "450px",
        divPaddingTop: formType === enums_1.FormType.DonationForm ? undefined : "450px",
        allowPaymentRequest: true,
        lazy: true,
    }),
});
exports.getFormEmbedCode = getFormEmbedCode;
const getThermometerEmbedCode = ({ frontendUrl, path }) => getEmbedHtml({
    src: `${frontendUrl}${(0, routes_1.getEmbedThermometerLink)(path, null)}`,
    iframHeight: "120px",
    divPaddingTop: "120px",
});
exports.getThermometerEmbedCode = getThermometerEmbedCode;
const getLeaderboardEmbedCode = ({ frontendUrl, path }) => getEmbedHtml({
    src: `${frontendUrl}${(0, routes_1.getEmbedLeaderboardLink)(path, null)}`,
    divPaddingTop: "240px",
    iframHeight: "100%",
});
exports.getLeaderboardEmbedCode = getLeaderboardEmbedCode;
